{
    "misc": {
        "chooselang": "SELECT [[Tounge Type]]",
        "langprogress": "[[Power Level of at the]]"
    },
    "header": {
        "home": "[[Homemade Storefront Site]]",
        "language": "[[Tounge Type]]",
        "about": "[[About Sir Spamtonese]]",
        "write": "IM THE [[Email Guy]]",
        "account": "S O U L"
    },
    "footer": {
        "disclaimer": "IS NOT A [[Officil Specil Deal]]",
        "headingabout": "[[Mailman]]",
        "headinglinks": "[[Cite your Sources]]",
        "headingcommunity": "[[the Public]]",
        "aboutlink": "MY [[Vehicular Biography]]",
        "licenselink": "LOOK AT MY [[real]] PHD",
        "statuslink": "[isspamtondead.com]]",
        "articleslink": "[[Mail]]",
        "googlebusinesslink": "[[Look at My!]]",
        "issuelink": "REPORT [[The Knight]]",
        "reviewlink": "[[Please set a 5 stars.]]",
        "forumlink": "LIGht>ners",
        "githublink": "[[git push]]",
        "discord": "[[Blue Chatting Device]]"
    },
    "main": {
        "welcome": "WELCOME TO THE [[Hyperlink Blocked]]",
        "back-cat": "BACK TO MY [[Catagorization]]",
        "readmore": "[[Specil Deal! Read More!]]",
        "by": "[[Authoring By:]]",
        "date": "[[time and date for  mat]]",
        "category": "[[Label Is the:]]"
    },
    "write": {
        "heading": "EXPAND THE [[Pipis]]",
        "title": "[[Title the]]",
        "author": "YOUR S O U L",
        "date": "[[Your time, now please]]",
        "category": "[[The Categorization]]",
        "content": "mY TEXT AND [[.png File Formats]]",
        "submit": "[[Submit at the]]",
        "cancel": "[[STOP! STOP! IT BURNNNSSSS!!]]",
        "unauthorised": "NO",
        "title-err": "[[Title is now gone.]]",
        "title-placeholder": "[[What do you want to   ?]]"
    },
    "signup": {
        "heading": "ACCOUNT NOW!!!!11",
        "email-placeholder": "[[I'm the email guy!]]",
        "password-placeholder": "[[Your password, please?]]",
        "username-placeholder": "[[Naming of the Public]]",
        "register": "MOR SPAM"
    },
    "login": {
        "emailpass-error": "I NEED YOUR [[Email and 3 digits on the Back?]]",
        "signin": "[[Sign Inonto the]]"
    },
    "account": {
        "welcome": "[[Hyperlink Blocked]]",
        "logout": "Mike... Why?",
        "login": "[[Log into my store]]",
        "signup": "[[Buy more Kromer!]]",
        "liketodo": "YOUR [[choices]]"
    }
}
